
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD-DuTuJ0xCzA7nqC-lGzYBnUh-m0Ht14M",
  authDomain: "fir-login-239ce.firebaseapp.com",
  projectId: "fir-login-239ce",
  storageBucket: "fir-login-239ce.firebasestorage.app",
  messagingSenderId: "522132492291",
  appId: "1:522132492291:web:2ae354ed7c8d50123f7e36"
};

// Firebase アプリを初期化
const app = initializeApp(firebaseConfig);

// 認証
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

// Firestore
const db = getFirestore(app); // ← Firestore インスタンス作成

export { auth, provider, db }; 